import Lesson from 'models/Lesson';
import React from 'react';
import Context from './context';

interface Props {
  lesson: Lesson;
}

const LessonProvider: React.FC<Props> = ({ lesson, children }) => (
  <Context.Provider value={{ lesson }}>{children}</Context.Provider>
);

export default LessonProvider;
